export default __webpack_public_path__ + "static/media/liberum-6.a64fb9f3.png";